import { useEffect, useState } from 'react';

/**
 * Tracks a CSS media query. Used for the card breakpoint and the coarse-pointer
 * check (data table pattern, style guide 2.53) — never the window width alone,
 * because a narrow desktop window is still a desktop.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const listener = (event: MediaQueryListEvent) => setMatches(event.matches);
    mq.addEventListener('change', listener);
    return () => mq.removeEventListener('change', listener);
  }, [query]);

  return matches;
}

/** Is the pointer a finger (touch), not a mouse/trackpad? Drives long-press selection and the mobile tools sheet. */
export function useCoarsePointer(): boolean {
  return useMediaQuery('(pointer: coarse)');
}
